/* eslint-disable import/no-cycle */
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import api from 'client';
import { dateUtils, sessionProvider, toastMessage } from 'utils';
import { fetchAccount, clearAccount } from 'store/actions/account';
import { useIntercom } from 'hooks';
import { useTranslation } from 'react-i18next';

export default () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { isBooted, shutdown } = useIntercom();
  const { t } = useTranslation('labels');

  const login = async (username, password) => {
    await sessionProvider.authenticate('authenticator:adracare', username.trim(), password);
    if (sessionProvider.get('providerAttemptedLogin')) {
      return true;
    }
    queryClient.invalidateQueries();
    await dispatch(fetchAccount());
  };

  const logout = async () => {
    if (isBooted.current) shutdown();
    sessionProvider.invalidate();
    await dispatch(clearAccount());
    queryClient.removeQueries();
  };

  const resetPassword = async (data) => {
    const { data: response } = await api.post('/apis/v2/password_resets/claim', data);
    return response;
  };

  const requestPasswordReset = async ({ email }) => api.post('/apis/v2/password_resets', { email });

  const getPasswordReset = async ({ tag }) => {
    try {
      const { data } = await api.get(`/apis/v2/password_resets?tag=${tag}`);
      const {
        data: {
          attributes: { expiresAt },
        },
      } = data;

      return { isExpired: dateUtils.isDateBeforeNow(expiresAt) };
    } catch (error) {
      return {
        isExpired: true,
      };
    }
  };

  const getAccountClaim = async ({ tag }) => {
    try {
      const response = await api.get(`/apis/v2/account_claims/${tag}`);
      if (response.status === 200) {
        return {
          profile: response.data,
          isExpired: false,
        };
      }
      return {
        isExpired: response.status > 400, //! dateUtils.isDateBeforeNow(expiresAt)
      };
    } catch (error) {
      return {
        isExpired: true,
      };
    }
  };

  const resendCode = async ({ tag }) => {
    try {
      const response = await api.post(`/apis/v2/account_claims/${tag}/resend_code`);
      if (response.status === 204) {
        toastMessage(t('success'), t('pin_texted_to_mobile_number'), true, 'success');
      }
    } catch (error) {
      toastMessage(t('error'), t('pin_request_limit_exceeded'), true, 'error');
    }
  };

  const createAccount = async ({ email, password, confirmPassword, code, tag }) => api.post(`/apis/v2/account_claims/${tag}/verify`, { email, password, confirmPassword, code });

  return {
    login,
    logout,
    getPasswordReset,
    resetPassword,
    requestPasswordReset,
    resendCode,
    createAccount,
    getAccountClaim,
  };
};
